import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';

export interface IVHSTypographySamplesProps extends IBaseElementProps {}

const VHSTypographySamples: React.FC<IVHSTypographySamplesProps> = ({
	className,
	classNames = [],
}) => (
	<div
		className={className || cn('vhs-typography-samples', ...classNames)}
	>
		<div className="vhs-container">
			<div className="row">
				<div className="col-12">
					<div className="content">
						<h2>
							Diam morbi a amet, purus in tellus ornare ornare
							(heading 2)
						</h2>

						<p>
							Lorem ipsum dolor sit amet, consectetur adipiscing
							elit. Quam tu ponis in verbis, ego positam in re
							putabam. Re mihi non aeque satisfacit, et quidem
							locis pluribus. A mene tu. Duo Reges. constructio
							interrete. Tu vero, inquam, ducas licet, si
							sequetur. Tum, Quintus et Pomponius cum idem se
							velle dixissent, Piso exorsus est. Progredientibus
							autem aetatibus sensim tardeve potius quasi nosmet
							ipsos cognoscimus. Sit enim idem caecus, debilis.
						</p>

						<ul>
							<li>
								Neque enim disputari sine reprehensione nec cum
								iracundia aut recte disputari potest.
							</li>
							<li>
								Si stante, hoc natura videlicet vult, salvam
								esse se, quod concedimus;
							</li>
						</ul>

						<p>
							Ut aliquid scire se gaudeant? Pudebit te, inquam,
							illius tabulae, quam cleanthes sane commode verbis
							depingere solebat. Quis istum dolorem timet? Quis,
							quaeso, illum negat et bonum virum et comem et
							humanum fuisse? Est enim effectrix multarum et
							magnarum voluptatum. Itaque nostrum est-quod nostrum
							dico, artis est-ad ea principia, quae accepimus.
							Quid censes in Latino fore? Aperiendum est igitur,
							quid sit voluptas; Quid ait Aristoteles reliquique
							Platonis alumni? Virtutis, magnitudinis animi,
							patientiae, fortitudinis.
						</p>

						<ul>
							<li>
								Immo istud quidem, inquam, quo loco quidque,
								nisi iniquum postulo, arbitratu meo.
							</li>
							<li>
								Quare, quoniam de primis naturae commodis satis
								dietum est nunc de maioribus consequentibusque
								videamus. Sit enim idem caecus, debilis..
							</li>
							<li>
								Parvi enim primo ortu sic iacent, tamquam omnino
								sine animo sint.
							</li>
						</ul>

						<p>
							<strong>
								Graecum enim hunc versum nostis omnes:
							</strong>{' '}
							Suavis laborum est praeteritorum memoria. Nihil ad
							rem! Ne sit sane; Dolor ergo, id est summum malum,
							metuetur semper, etiamsi non aderit; Quid enim me
							prohiberet Epicureum esse, si probarem, quae ille
							diceret? <a href="#">Expectoque quid ad id,</a> quod
							quaerebam, respondeas. Si mala non sunt, iacet omnis
							ratio Peripateticorum.
						</p>

						<p>
							Quos nisi redarguimus, omnis virtus, omne decus,
							omnis vera laus deserenda est. Sed venio ad
							inconstantiae crimen, ne saepius dicas me aberrare;
							Ac tamen hic mallet non dolere. Atque haec ita
							iustitiae propria sunt, ut sint virtutum reliquarum
							communia. Ut non sine causa ex iis memoriae ducta
							sit disciplina. Sed residamus, inquit, si placet.
							Quod quidem nobis non saepe contingit.
						</p>

						<h3>Nam ista vestra: Si gravis, brevis (heading 3)</h3>

						<p>
							Pudebit te, inquam, illius tabulae, quam Cleanthes
							sane commode verbis depingere solebat. Hos contra
							singulos dici est melius. Hoc non est positum in
							nostra actione. Traditur, inquit, ab Epicuro ratio
							neglegendi doloris. Nam Metrodorum non puto ipsum
							professum, sed, cum appellaretur ab Epicuro,
							repudiare tantum beneficium noluisse; Stoici
							scilicet. Memini vero, inquam; Scio enim esse
							quosdam, qui quavis lingua philosophari possint;
							Obsecro, inquit, Torquate, haec dicit Epicurus? Quid
							enim est a Chrysippo praetermissum in Stoicis?
							Fortemne possumus dicere eundem illum Torquatum? Et
							ille ridens: Video, inquit, quid agas; Venit ad
							extremum; Sed quanta sit alias, nunc tantum possitne
							esse commodo felis quis tortor tanta.
						</p>

						<h4>
							Ergo illi intellegunt quid Epicurus dicat, ego
							intellego? (heading 4)
						</h4>

						<p>
							Donec nec justo eget felis facilisis fermentum.
							Aliquam porttitor mauris sit amet orci. Aenean
							dignissim pellentesque tincidunt mauris eu risus
							felis.
						</p>

						<ol>
							<li>At eum nihili facit;</li>
							<li>Sit enim idem caecus, debilis.</li>
							<li>
								Sed tamen enitar et, si minus multa mihi
								occurrent, non fugiam ista popularia.
							</li>
							<li>
								Tamen aberramus a proposito, et, ne longius,
								prorsus, inquam, Piso, si ista mala sunt.
							</li>
							<li>
								Ergo ita: non posse honeste vivi, nisi honeste
								vivatur?
							</li>
						</ol>

						<h5>
							Nullam pharetra pellentesque ullamcorper scelerisque
							eget elementum (heading 5)
						</h5>

						<h6>
							Duis erat malesuada aliquet facilisis aenean mi
							(heading 6)
						</h6>
					</div>
				</div>
			</div>
		</div>
	</div>
);

export default VHSTypographySamples;
